import React, { useEffect, useState } from 'react';
import Icon from './icons';
import { useDispatch } from 'react-redux';
import { ACTIONS, URLS, APIS, STORAGE } from '../_config';
import { Link, useNavigate, Outlet, Navigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useUserApi } from '../store/api/hooks/userApiHook';
import Swal from 'sweetalert2';
import { SwalService } from './confirmation-popup/swalService';
import { store } from '../store';
import { useMenuToggleSelector } from '../store/selectors/menuToggleSelector';

interface IncomingProps {
    sideMenuBarClass: string;
}

const SideMenuBar = ({sideMenuBarClass}: IncomingProps) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [selectedMenu, setSelectedMenu] = useState<string>('');

    const userAPI: any = useUserApi();
    const navigate = useNavigate();
    const dispach = useDispatch();
    const location = useLocation();
    const menuToggle = useMenuToggleSelector();

    const isActive = (path: any) => location.pathname === path ? 'active' : '';

    const handleMenuClick = (menu: string) => {
        setSelectedMenu(menu);
    };

    const handleLogout = () => {
        logout();
    };

    const handleClick = () => {
        SwalService.triggerSwal(
            'Logout',
            'Are you sure you want to log out?',
            handleLogout
        );
    };

    const showConfirm = () => {
        Swal.fire({
            title: 'Logout',
            text: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Continue!',
            cancelButtonText: 'Cancel',
            customClass: {
                container: 'bg-gray-800',
                popup: 'bg-white rounded-lg shadow-lg p-6',
                title: 'text-2xl font-semibold text-red-500',
                confirmButton: 'bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded',
                cancelButton: 'bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 px-4 rounded',
            }
        }).then((result) => {
            if (result.isConfirmed) {
                logout();
            }
        });
    };

    const logout = () => {
        try {
            userAPI.logout({}, (message: any, resp: any) => {
                localStorage.removeItem(STORAGE);
                dispach({ type: ACTIONS.USER.LOGOUT, payload: {} })
                dispach({ type: ACTIONS.PUSHER.RESET_DATA, payload: [] })
                navigate(URLS.USER.LOGIN);
                toast.success('User Logged Out Successfully');
            }, (err: any, resp: any) => {
                // console.log('error =>', err, resp);
                if (resp.message == 'User logged out, session removed') {
                    dispach({ type: ACTIONS.USER.LOGOUT, payload: {} })
                    dispach({ type: ACTIONS.PUSHER.RESET_DATA, payload: [] })
                    navigate(URLS.USER.LOGIN);
                    toast.success('User Logged Out Successfully');
                }
            });
        } catch (e: any) {
            console.log('error =>', e);
            toast.error(e?.message);
        }
    }

    const handleMenuToggle = () => {
        store.dispatch({
            type: ACTIONS.MENU.TOGGLE,
        });
    };

    return (
    <div className={"mobile-menu " + sideMenuBarClass + (menuToggle ? " menu-open" : " menu-close")}>
        <div className="mobile-menu-icon">
            {menuToggle ? (
                <div onClick={handleMenuToggle}>
                <img src="/assets/images/close_icon.png" alt="close" />
                </div>
            ) : (
                <div onClick={handleMenuToggle}>
                <img src="/assets/images/open_icon.png" alt="open" />
                </div>
            )}
        </div>
        <div className={`flex ${isSidebarOpen ? 'w-64' : 'w-16'} h-full transition-width duration-300 bg-white-800 text-white left-0 top-0 z-50 border-white`}>
            {/* Sidebar content */}
            <div className="flex flex-col w-full h-full">
                {/* <div className="p-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="w-[32px] h-[32px] rounded-full overflow-hidden"> */}
                {/* <img src={(user?.profilePicture !== '') ? user?.profilePicture : noUserImg} alt="User" className="w-full" /> */}
                {/* </div>
                        {isSidebarOpen && <p className="text-sm"></p>}
                    </div>
                </div> */}

                {/* Sidebar Links */}
                <div className='inner-page-logo'>
                    <img className="" src="/assets/images/Frame_2.png" alt="hubwallet logo" />
                </div>
                <div className="flex flex-col flex-grow">
                    <Link
                        to="#"
                        className={`bg-gray-300 text-gray-900 text-base py-2 px-4 pointer-events-none opacity-[0.7]`}
                        onClick={() => {
                            handleMenuClick('analysis');
                        }}
                    >
                        Analysis
                    </Link>
                    <Link
                        to="/sentiment-analysis"
                        className={`py-2 px-4 text-base ${selectedMenu === 'sentiment' || isActive('/sentiment-analysis') ? 'bg-blue-500 text-white active' : 'text-gray-600 hover:bg-blue-500 hover:text-white'}`}
                        onClick={() => handleMenuClick('sentiment')}
                    >
                        Sentiment Analysis
                    </Link>
                    <Link
                        to="/reviews"
                        className={`py-2 px-4 text-base ${selectedMenu === 'reviews' || isActive('/reviews') ? 'bg-blue-500 text-white' : 'text-gray-600 hover:bg-blue-500 hover:text-white'}`}
                        onClick={() => handleMenuClick('reviews')}
                    >
                        Reviews
                    </Link>
                    <Link
                        to="/ratings"
                        className={`py-2 px-4 text-base ${selectedMenu === 'ratings' || isActive('/ratings') ? 'bg-blue-500 text-white' : 'text-gray-600 hover:bg-blue-500 hover:text-white'}`}
                        onClick={() => handleMenuClick('ratings')}
                    >
                        Ratings
                    </Link>
                    <Link to="#"
                        className={`bg-gray-300 text-gray-900 text-base py-2 px-4 pointer-events-none opacity-[0.7]`}
                        onClick={() => handleMenuClick('insight')}
                    >
                        Insight
                    </Link>

                    <Link
                        to="/topics"
                        className={`py-2 px-4 text-base ${selectedMenu === 'topics' || isActive('/topics') ? 'bg-blue-500 text-white' : 'text-gray-600 hover:bg-blue-500 hover:text-white'}`}
                        onClick={() => handleMenuClick('topics')}
                    >
                        Topics
                    </Link>
                    <Link to="/words"
                        className={`py-2 px-4 text-base ${selectedMenu === 'words' || isActive('/words') ? 'bg-blue-500 text-white' : 'text-gray-600 hover:bg-blue-500 hover:text-white'}`}
                        onClick={() => handleMenuClick('words')}
                    >
                        Words
                    </Link>
                    <Link
                        to="/recomendation"
                        className={`py-2 px-4 text-base ${selectedMenu === 'recomendation' || isActive('/recomendation') ? 'bg-blue-500 text-white' : 'text-gray-600 hover:bg-blue-500 hover:text-white'}`}
                        onClick={() => handleMenuClick('recomendation')}
                    >
                        Recommendation
                    </Link>
                    {/* <Link
                        to="#"
                        className={`bg-gray-100 text-gray-600 py-2 px-4 text-base pointer-events-none opacity-[0.5]`}
                        onClick={() => handleMenuClick('audience')}
                    >
                        Audience
                    </Link>
                    <Link
                        to="/emotions"
                        className={`py-2 px-4 text-base ${selectedMenu === 'emotions' || isActive('/emotions') ? 'bg-blue-500 text-white' : 'text-gray-600 hover:bg-blue-500 hover:text-white'}`}
                        onClick={() => handleMenuClick('emotions')}
                    >
                        Emotions
                    </Link> */}
                    <Link
                        to="#"
                        className={`bg-gray-300 text-gray-900 text-base py-2 px-4 pointer-events-none opacity-[0.7]`}
                        onClick={() => handleMenuClick('others')}
                    >
                        Others
                    </Link>
                    <Link
                        to="/assistant"
                        className={`py-2 px-4 text-base ${selectedMenu === 'assistant' || isActive('/assistant') ? 'bg-blue-500 text-white' : 'text-gray-600 hover:bg-blue-500 hover:text-white'}`}
                        onClick={() => handleMenuClick('assistant')}
                    >
                        HubWallet Assistant
                    </Link>
                    <Link
                        to="/datasources/create"
                        className={`py-2 px-4 text-base ${selectedMenu === 'datasources' || isActive('/datasources') || isActive('/datasources/create') ? 'bg-blue-500 text-white' : 'text-gray-600 hover:bg-blue-500 hover:text-white'}`}
                        onClick={() => handleMenuClick('datasources')}
                    >
                        DataSource
                    </Link>
                    <Link
                        to="/settings"
                        className={`py-2 px-4 text-base ${selectedMenu === 'settings' || isActive('/settings') ? 'bg-blue-500 text-white' : 'text-gray-600 hover:bg-blue-500 hover:text-white'}`}
                        onClick={() => handleMenuClick('settings')}
                    >
                        Settings
                    </Link>

                    {/* <button
                        onClick={() => handleClick()}
                        className="bg-red-400 text-left text-white py-1 px-4 mt-auto h-[55px] hover:bg-red-400 w-full text-base"
                    >
                        Logout
                    </button> */}
                    <button
                        onClick={() => handleClick()}
                        className="bg-red-400 text-left text-white py-1 px-4 mt-auto h-[55px] hover:bg-red-400 w-full text-base"
                    >
                    {/* <Icon name="logout" size={20} className="text-red-500" /> */}
                    Logout
                    </button>
                </div>
            </div>
        </div>
    </div>
    );
};

export default SideMenuBar;